/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplatesControllerFindOneQueryResponse, TemplatesControllerFindOnePathParams, TemplatesControllerFindOneQueryParams, TemplatesControllerFindOne400, TemplatesControllerFindOne401, TemplatesControllerFindOne403, TemplatesControllerFindOne404 } from "../../models/checklistsController/TemplatesControllerFindOne";

function getTemplatesControllerFindOneUrl(id: TemplatesControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/checklist-templates/${id}` as const }  
  return res
}

/**
 * @summary Get a specific checklist template by ID
 * {@link /api/v1/checklist-templates/:id}
 */
export async function templatesControllerFindOne(id: TemplatesControllerFindOnePathParams["id"], params?: TemplatesControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplatesControllerFindOneQueryResponse, ResponseErrorConfig<TemplatesControllerFindOne400 | TemplatesControllerFindOne401 | TemplatesControllerFindOne403 | TemplatesControllerFindOne404>, unknown>({ method : "GET", url : getTemplatesControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}